module.exports = __webpack_public_path__ + "img/js.3c61854d.png";